import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props { children: ReactNode }
interface State { error: Error | null }

/** Last line of defence: a render error must never blank the whole site. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[PulseBoard] render error", error, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.error) return this.props.children;
    return (
      <main style={{ maxWidth: 560, margin: "64px auto", padding: "0 24px", fontFamily: "Geist, system-ui, sans-serif" }}>
        <p style={{ fontSize: 12, letterSpacing: ".08em", textTransform: "uppercase", color: "#1F8A8A" }}>PulseBoard</p>
        <h1 style={{ fontSize: 28, margin: "8px 0 12px" }}>Something went wrong on this page.</h1>
        <p style={{ color: "#4B5560", lineHeight: 1.5 }}>
          The rest of PulseBoard is unaffected. Reload to try again, or go back to the directory.
          If it keeps happening, email hello@pulseboard.com.au with the page address.
        </p>
        <p style={{ marginTop: 20 }}>
          <a href="/directory" style={{ color: "#166B6B", fontWeight: 600 }}>Back to the directory</a>
          {" · "}
          <button type="button" onClick={() => window.location.reload()} style={{ color: "#166B6B", fontWeight: 600, background: "none", border: 0, padding: 0, cursor: "pointer", font: "inherit" }}>Reload</button>
        </p>
      </main>
    );
  }
}
